import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { LaunchDialogService } from '@spartacus/storefront';
import { firstValueFrom, map } from 'rxjs';

@Component({
  selector: 'app-modal-ponumber',
  standalone: true,
  imports: [CommonModule, I18nModule],
  templateUrl: './modal-ponumber.component.html',
  styleUrl: './modal-ponumber.component.scss'
})
export class ModalPonumberComponent {
  launchDialogService = inject(LaunchDialogService);

  data$ = this.launchDialogService.data$;

  nextStepCheckoutMethod$ = this.data$.pipe(map((d) => d?.nextStepCheckout ?? null));

  async ok() {
    const nextStepCheckout = await firstValueFrom(this.nextStepCheckoutMethod$);

    if (typeof nextStepCheckout === 'function') {
      nextStepCheckout();
    }

    this.launchDialogService.closeDialog('close');
    this.launchDialogService.clear('MISSING_PO_NUMBER_MODAL');
  }

  dismiss() {
    this.launchDialogService.closeDialog('close');
    this.launchDialogService.clear('MISSING_PO_NUMBER_MODAL');
  }
}
